import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'
import heroWebp3x from './assets/Hero@3x.webp'

const copy = {
  overline: `E-Commerce `,
  heading: `Bring your store to your customers`,
  description: `From connecting every touchpoint to choosing the perfect product recommendations, Segment empowers retailers to deliver the most compelling customer experience.`,
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline tag="h5">{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>

          <HeroRecipe.Form>
            <StyledDemoForm
              isProgressive={true}
              customFormIdentifier="site-industry-retail-demo"
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x, ${heroWebp3x} 3x`} />
            <HeroRecipe.Image width="537" height="464" src={heroPng2x} alt="Hero" loading="lazy" />
          </Picture>
        </HeroRecipe.Contents>
      </StyledHeroBase>
    </Wrapper>
  )
}

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Contents} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      justify-content: left;
    }
  }
`

const StyledDemoForm = styled(DemoForm)`
  margin-top: 40px;
`

const Wrapper = styled.header`
  padding-top: 0;
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[1]});

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 540px;
    padding-top: 80px;
  }
`
export default Hero
